/**
 * Entry de build del artefacto `bridge.js` servido desde el dominio de Iris
 * como `/bridge/v1/bridge.js` (VERSIONADO POR URL, ADR 0003). Lo carga el sitio
 * host con un `<script>`; expone `window.IrisBridge` y auto-inicializa si el
 * host ya declaró `window.IrisHostConfig` (variante declarativa). La variante
 * JS con `proveedorCarrito` es `IrisBridge.init({...})`.
 *
 * Empaquetado en formato IIFE por `vite.bridge.config.ts` (sin deps externas):
 * es autónomo y no comparte bundle con el shell (que corre en el iframe).
 */
import { IrisBridge, initIrisBridge } from "./bridge"

declare global {
  interface Window {
    IrisBridge?: typeof IrisBridge
    IrisHostConfig?: unknown
  }
}

if (typeof window !== "undefined") {
  window.IrisBridge = IrisBridge
  // Auto-init declarativo: si el host puso IrisHostConfig antes de cargar el
  // script, montamos de una. Con proveedorCarrito, el host llama init() él mismo.
  if (window.IrisHostConfig) {
    try {
      initIrisBridge()
    } catch (e) {
      console.warn("[iris-bridge] auto-init falló:", e)
    }
  }
}

// Export DEFAULT (no `export { IrisBridge }`): con el IIFE de Vite + `name:"IrisBridge"`,
// un export nombrado hace `window.IrisBridge = { IrisBridge }` (anidado) y pisa el
// side-effect de arriba, dejando `window.IrisBridge.init` undefined. El default hace
// `window.IrisBridge = IrisBridge` (el objeto {init, comandos, version}) — que es lo que
// el puente del host y el boot esperan.
export default IrisBridge
